import { useCallback, useState } from 'react';

export const useFunctionInterval = (callback, interval = 1000) => {
  const [timer, setTimer] = useState(null);

  const debounce = useCallback(
    (...args) => {
      clearTimeout(timer);
      setTimer(setTimeout(callback.bind(null, ...args), interval));
    },
    [timer, interval, callback]
  );

  return debounce;
};
